module.exports = __webpack_public_path__ + "img/Notification.626f6334.png";